module.exports = __webpack_public_path__ + "static/img/partner-logo5@3x.378dbbb9.png";